import { Component } from 'react'
import { $, getError } from 'utils'
import styled from 'glamorous'
import { withRouter, Link } from 'react-router-dom'
import { graphql } from 'react-apollo'

import { withConsumer } from 'store'
import { CHECK_ACCOUNT as query, SignInMutation, SignUpMutation } from 'queries'
import { Icon, Button, Checkbox } from 'components'

import Input from './SignInput'

const MainForm = styled.div({
  position: 'absolute',
  width: 758,
  height: 430,
  top: '50%',
  left: '50%',
  marginLeft: -379,
  marginTop: -215,
  display: 'flex',
  boxShadow: '0px 20px 32px 0 rgba(0, 0, 0, 0.11)',
})

const LogoContainer = styled.div({
  width: 280,
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: '#636363',
  backgroundImage: 'url(/images/bg_pic_02.png)',
  backgroundPosition: 'no-repeat',
  backgroundSize: 'cover'
})

const LogoInnerContainer = styled.div({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
})

const LogoIcon = styled.div({
  marginTop: -25
})

const LogoLabel = styled.div({
  marginTop: 15,
  fontSize: 30,
  fontWeight: 700,
  letterSpacing: 4.9,
  textTransform:'uppercase',
  color: '#fefefe'
})

const LogoSublabel = styled.div({
  fontSize: 20,
  fontWeight: 700,
  letterSpacing: 4.9,
  textTransform:'uppercase',
  color: '#fefefe'
})

const LogoDescription = styled.div({
  marginTop: 10,
  width: 200,
  fontSize: 18,
  color: 'var(--white)',
  textAlign: 'center',
  opacity: 0.6,
})

const ContentContainer = styled.div({
  flex: 1,
  padding: '45px 60px 35px 50px',
  backgroundColor: 'var(--white)',
  display: 'flex',
  flexDirection: 'column',

})

const Header = styled.div({
  display: 'flex',
  alignItems: 'baseline',
})

const OrLabel = styled.div({
  color: 'var(--lightGrey)',
  fontSize: 19,
  margin: '0 15px'
})

const SignLabel = styled(Link)({
  fontSize: 27,
  color: 'var(--lightGrey)',
  cursor: 'pointer',
  textDecoration: 'none',
}, ({ selected }) => selected && ({
  color: 'var(--black)'
}))

const InputsContainer = styled.div({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
})

const BottomBar = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
})

const RememberContainer = styled.div({
  display: 'flex',
  marginLeft: 30
})

const Remember = styled.div({
  marginLeft: 10,
  fontSize: 15,
  color: 'var(--grey)'
})

const Error = styled.div({
  height: 20,
  marginTop: 10,
  fontSize: 13,
  color: 'var(--red)'
})


class SignForm extends Component {

  state = {
    organizationName: '',
    login: '',
    password: '',
    confirmPassword: '',
    remember: false,
    error: ''
  }

  handleChange = (type) => (value) =>
    this.setState({[type]: value, error: ''})

  handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      this.props.isSignUp ? this.signUp() : this.signIn()
    }
  }

  signIn = () => this.props.mutate({
    variables: {
      login: this.state.login,
      password: this.state.password,
    },
    update: (proxy, { data: { login } }) => {
      const data = proxy.readQuery({ query })
      login.__typename = 'Account'
      // TODO we should also remove 'ok' in terms of consistency to the type
      data.account = login
      proxy.writeQuery({ query, data })
    }
  }).then(({ data }) => data.login.ok && this.props.history.push('/'))
    .catch(error => this.props.setErrorMessage(getError(error)))

  signUp = () => {
    const { login, password, confirmPassword, organizationName } = this.state
    if (password !== confirmPassword) {
      this.setState({
        error: 'Please make sure your password match'
      })
    } else {
      this.props.mutate({
        variables: {
          email: login,
          password: password,
          organizationName: organizationName,
        },
        update: (proxy, { data: { registerAccount } }) => {
          const data = proxy.readQuery({ query })
          const newData = {
            __typename: 'Account',
            email: registerAccount.account.email,
            organizationName: registerAccount.account.organizationName,
            ok: true,
          }
          data.account = newData
          proxy.writeQuery({ query, data })
        }
      })
        .then((response) => {
          if (!!response.data) {
            this.props.history.push('')
          }
        })
        .catch(error => this.props.setErrorMessage(getError(error)))
    }
  }

  render() {
    const { isSignUp } = this.props
    const { organizationName, login, password, confirmPassword, remember } = this.state

    return (

      $(MainForm,
        $(LogoContainer,
          $(LogoInnerContainer,
            $(LogoIcon, $(Icon, {type: 'luna', size: 99, color: 'var(--white)', isHoverable: false})),
            $(LogoLabel, 'Luna'),
            $(LogoSublabel, 'Platform'),
            $(LogoDescription, 'Facial verification and identification system')
          )
        ),
        $(ContentContainer,
          $(Header,
            $(SignLabel, {
              selected: !isSignUp,
              to: '/signIn',
            }, 'Sign in'),
            $(OrLabel, 'or'),
            $(SignLabel, {
              selected: isSignUp,
              to: '/signUp',
            }, 'Sign up'),
          ),
          // TODO Refactor to two separate components with local routing
          $(InputsContainer, { onKeyDown: this.handleKeyDown },
            isSignUp &&
              $(Input, {
                value: organizationName,
                onChange: this.handleChange('organizationName'),
                placeholder: 'Organization'
              }),
            $(Input, {
              value: login,
              onChange: this.handleChange('login'),
              placeholder: 'Email address'
            }),
            $(Input, {
              value: password,
              onChange: this.handleChange('password'),
              type: 'password',
              placeholder: 'Password'
            }),
            isSignUp &&
              $(Input, {
                value: confirmPassword,
                onChange: this.handleChange('confirmPassword'),
                type: 'password',
                placeholder: 'Confirm password'
              }),
            this.state.error &&
              $(Error, this.state.error)
          ),
          $(BottomBar,
            $(Button, {
              bgColor: 'var(--violet)',
              primary: true,
              width: '135px',
              onClick: isSignUp ? this.signUp : this.signIn,
              style: { height: 40 }
            }, isSignUp ? 'Sign up' : 'Sign in'),
            $(RememberContainer,
              $(Checkbox, {
                type: 'violet',
                selected: remember,
                onChange: () => this.setState({ remember: !remember }),
                label: $(Remember, 'remember the password')
              }),
            ),
          ),
        )
      )
    )
  }
}

const SignWithRouter = withRouter(withConsumer(SignForm))

export const SignIn = graphql(SignInMutation)(SignWithRouter)
export const SignUp = graphql(SignUpMutation)(SignWithRouter)



// WEBPACK FOOTER //
// ./src/pages/SignLayout/SignForm.js